const stylesAgent = {
  render: {
    fontSize: "14px",
    color: "darkgray",
    marginTop: "0.5rem",
       fontFamily: "Raleway, sans-serif"
  },
  divP: {
    width: "100%",
  },
  title: {
    textAlign: "left",
    color:"#4c4c4c",
    marginTop: "2rem",
    marginLeft: "2rem",
    opacity: "0.7",
    fontWeight: "bold",
    fontFamily: "Raleway,sans-serif"
  },
  divS: {
    textAlign: "left",
    marginLeft:"1rem",
    width:"95%"
  },
input: {
  width: "15rem",
  borderRadius: "0.7rem",
  border: "none", // quitar el borde completamente
  fontSize: "0.9rem",
  padding: "10px",
  marginTop: "1.2rem",
  fontFamily: "Raleway, sans-serif",
  outline: "none", // quita el borde negro del focus

  boxShadow: "0 0 10px rgba(0, 0, 0, 0.15)", // sombra más visible

  '&:focus': {
    outline: "none",
    boxShadow: "0 0 8px rgba(0, 0, 0, 0.2)", // sombra más fuerte al enfocar
  },
},
  inputEdit: {
    width: '100%',
    borderRadius: "5px",
    border:"1px solid lightgray",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    fontSize: "0.9rem",
    padding: "10px",
    marginTop:"1.2rem"
  },
  stackPag: {
    width: "100%",
    margin: "10px",
  },
  pagination: {
    marginTop: "0.5rem",
    fontFamily: 'Raleway, sans-serif',
    '& .MuiTablePagination-toolbar': {
      fontFamily: 'Raleway, sans-serif',
    },
    '& .MuiTablePagination-selectLabel': {
      fontFamily: 'Raleway, sans-serif',
    },
    '& .MuiTablePagination-displayedRows': {
      fontFamily: 'Raleway, sans-serif',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'Raleway, sans-serif',
    },
  },
  divT: {
    marginTop: "2rem",
  },
  divButton: {
    marginRight: "1rem",
  },
  sxN: {
    textAlign: "left",
  },
  sxM: {
    width: "50%",
    marginLeft: "1rem",
  },
  typography: {
    fontSize: "16px",
    color: "#4C4C4C",
    marginTop: "1rem",
    opacity: "0.7",
    fontFamily: "Raleway, sans-serif",
  },
};

export default stylesAgent;
